//External
import Link from "next/link";
import React, { useEffect, useRef, useState } from "react";
import Slider from "react-slick";
import { getFadeFlag } from "utils";
//Internal
import noImage from "../../public/assets/images/No-Image.jpg";

/*******************
@Purpose : Used for single slider
@Parameter : {data, slugUrl}
@Author : INIC
******************/
function SingleSlider({ data, slugUrl, flag = "otherPage", onLinkClick }) {
  const [sliderData, setSliderData] = useState("");
  const [settings, setSettings] = useState({});
  const sliderRef = useRef();

  // If mobile then slider is disable in special section on home page
  useEffect(() => {
    let primaryImageObj = [];
    let withoutPrimaryImageObj = [];
    let processObj = [];
    let arrowFlag = "";

    data &&
      data.forEach(function (row) {
        if (row.is_primary) {
          primaryImageObj.push(row);
        } else {
          withoutPrimaryImageObj.push(row);
        }
      });

    processObj.push(primaryImageObj);
    if (window.screen.width < 1024 && flag == "home") {
      processObj = [...primaryImageObj];
      arrowFlag = false;
    } else {
      processObj.push(withoutPrimaryImageObj);
      processObj = [...primaryImageObj, ...withoutPrimaryImageObj];
      arrowFlag = true;
    }
    setSliderData(processObj);
    let tempObj = {
      dots: false,
      infinite: false,
      speed: 200,
      arrows: arrowFlag,
      slidesToShow: 1,
      slidesToScroll: 1,
      cssEase: "linear",
      slide: "> div",
      fade: getFadeFlag(),
    };
    setSettings(tempObj);
    // No <Slider> is rendered (and so no ref) when there are no images at all.
    sliderRef.current?.slickGoTo(0, true);
  }, [data]);

  /*******************
   @purpose : Render HTML/ React Components
   @Author : INIC
   ******************/
  const handleLinkClick = onLinkClick
    ? (e) => {
        e.preventDefault();
        onLinkClick();
      }
    : undefined;

  if (!sliderData || sliderData.length === 0) {
    return (
      <Link href={slugUrl}>
        <a onClick={handleLinkClick}>
          <div className="slider-item">
            <picture>
              <img
                src={noImage}
                className="img-fluid drive-car-dp"
                alt="No image available"
                title="No image available"
              />
            </picture>
          </div>
        </a>
      </Link>
    );
  }

  return (
    <Slider {...settings} className="single-slider" ref={sliderRef}>
      {sliderData.map((row, index) => (
        <Link href={slugUrl} key={index}>
          <a onClick={handleLinkClick}>
            <div className="slider-item">
              {
                <picture>
                  {/* <source
                    // srcSet={row?.image?.small?.webp_715}
                    srcSet={row?.image?.main}
                    type="image/webp"
                    alt={row?.alt}
                    title={row?.alt}
                  />
                  <source
                    // srcSet={row?.image?.small?.jpeg_715}
                    srcSet={row?.image?.main}
                    type="image/jpg"
                    alt={row?.alt}
                    title={row?.alt}
                  /> */}
                  <img
                    // src={row?.image?.small?.jpeg_715}
                    src={row?.image?.main}
                    className="img-fluid drive-car-dp"
                    alt={row?.alt}
                    title={row?.alt}
                    onError={(e) => {
                      if (e.target.src !== noImage) {
                        e.target.src = noImage;
                      }
                    }}
                  />
                </picture>
              }
            </div>
          </a>
        </Link>
      ))}
    </Slider>
  );
}
export default SingleSlider;
